import LandingComposer from './LandingComposer';
import { HERO_COPY, PROMPT_SUGGESTIONS } from './landingContent';
import { useLandingReveal, usePrefersReducedMotion } from './useLandingReveal';

/**
 * Hand-drawn sepia underline beneath the headline accent phrase. The stroke
 * carries the pen-sketch feel used across the landing artwork and draws
 * itself in once the hero reveals.
 */
function HeroUnderline() {
  return (
    <svg
      className="lp-hero__underline"
      viewBox="0 0 300 22"
      aria-hidden="true"
      focusable="false"
    >
      <path
        className="lp-hero__underline-path"
        d="M4 12.5 C 52 5.5, 118 4.2, 176 6.8 C 226 9, 268 11.6, 296 9.4"
      />
    </svg>
  );
}

function LandingHero({ composerProps, sentinelRef, decoration = null }) {
  const reducedMotion = usePrefersReducedMotion();
  const [revealRef, revealed] = useLandingReveal();

  return (
    <section className="lp-hero" aria-labelledby="lp-hero-heading">
      {decoration}
      <div className="lp-container">
        <div
          ref={revealRef}
          className={`lp-reveal${revealed || reducedMotion ? ' lp-reveal--visible' : ''}`}
        >
          <h1 id="lp-hero-heading" className="lp-hero__headline">
            {HERO_COPY.headlineLead}{' '}
            <span
              className={`lp-hero__accent${
                revealed || reducedMotion ? ' lp-hero__accent--drawn' : ''
              }`}
            >
              {HERO_COPY.headlineAccent}
              <HeroUnderline />
            </span>
            .
          </h1>
          <p className="lp-hero__subheadline">{HERO_COPY.subheadline}</p>
        </div>
        <div ref={sentinelRef} aria-hidden="true" />

        <div className="lp-hero__composer">
          <LandingComposer
            {...composerProps}
            location="hero"
            placeholder={HERO_COPY.placeholder}
            suggestions={PROMPT_SUGGESTIONS}
            riskReversal={HERO_COPY.riskReversal}
          />
        </div>
      </div>
    </section>
  );
}

export default LandingHero;
